<template>
  <!-- v-on:click="ListText=='去使用'?ticketClick(CouponInfo):''" -->
  <div class="MycouponList">
    <div class="Mycoupon">
      <div class="tabTicketLeft">
        <!-- <div  v-if="item.category!='免费券'">
              <div class="TickGoodMoney" style="margin-right:0.5rem">
                <span>￥</span>
                <span v-if="item.category=='优惠券'||item.category=='礼品券'">{{item.amount}}</span>
              </div>
              <div style="text-align:center">{{item.category}}</div>
            </div>
            <div  v-if="item.category=='免费券'">
              <div
                class="TickGoodMoney"
                style="margin-right:0.5rem;margin-left:0;"
              >
                <span></span>
                <span>免</span>
              </div>
            </div> -->
        <div class="category">{{ CouponInfo.category }}</div>
        <div class="tabTicketInfo">
          <div>·{{ CouponInfo.shop_info.name }}</div>
          <div v-if="CouponInfo.category == '免费券'">
            ·{{
              CouponInfo.name
                ? "免费商品：" + CouponInfo.name
                : "免费金额：" + CouponInfo.amount + "元"
            }}
          </div>
          <div v-else-if="CouponInfo.category == '礼品券'">
            ·购：{{ CouponInfo.gift }}
          </div>
          <div v-else-if="CouponInfo.category == '优惠券'">
            ·满{{ CouponInfo.reduce_rule }}
          </div>

          <div v-if="CouponInfo.category == '免费券'">
            ·限领数量：{{ CouponInfo.limitnumber }}
          </div>
          <div v-else-if="CouponInfo.category == '礼品券'">
            ·送：{{ CouponInfo.name }}
          </div>
          <div v-else-if="CouponInfo.category == '优惠券'">
            ·减{{ CouponInfo.amount }}
          </div>

          <div v-on:click="watchRule(CouponInfo.use_rule)">
            ·{{ CouponInfo.use_rule }}
          </div>
          <div>·截止：{{ CouponInfo.end_time.substring(0, 11) }}</div>
        </div>
      </div>
      <!-- <router-link :to="{name: toUrl, query: { 'CouponInfo': CouponInfo,'IconImg':IconImg}}" > -->
      <div
        class="share"
        v-if="type == 'Mycoupon' && MycouponIndex == 0"
        v-on:click="shareCoupon(CouponInfo)"
      >
        转增
      </div>
      <div class="toUse" v-on:click="ticketClick(CouponInfo)">
        {{ ListText }}
      </div>
      <!-- </router-link> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "MycouponList",
  props: ["MycouponIndex", "type", "CouponInfo", "IconImg", "index", "idxs"],
  data() {
    return {
      ListText: "",
      toUrl: "",

      CShttp: this.$store.state.CShttp,
      imageUrl: this.$store.state.CShttp + this.IconImg,
      codesEWM: this.CouponInfo.pcodes,
    };
  },
  components: {},
  created() {},
  mounted() {
    this.setListText();
    this.change();
  },
  methods: {
    // 查看规则
    watchRule(rule) {
      alert(rule);
    },
    setListText() {
      if (this.type == "MyAttention") {
        this.ListText = "点击领取";
        this.toUrl = "";
      }
      if (this.type == "Mycoupon") {
        this.ListText = "去使用";
        this.toUrl = "toUse";
      }
    },
    change() {
      if (this.type == "Mycoupon") {
        if (this.MycouponIndex == 0) {
          console.log("当前有效");
          $(".Mycoupon").css({
            backgroundImage: "url( " + require("../assets/Mycoupon.png") + ")",
          });
          $(".tabTicketInfo").css({
            color: "#ffe5a6",
          });
          $(".TickGoodMoney span").css({
            color: "#ffe5a6",
          });
          $(".toUse").text("去使用").css({
            color: "#cd160d",
          });
        } else {
          console.log("已失效");
          $(".Mycoupon").css({
            backgroundImage:
              "url( " + require("../assets/MycouponUsed.png") + ")",
          });
          $(".tabTicketInfo").css({
            color: "#484848",
          });
          $(".TickGoodMoney span").css({
            color: "#484848",
          });
          if (this.MycouponIndex == 1) {
            this.ListText = "已使用";
          }
          if (this.MycouponIndex == 2) {
            this.ListText = "已失效";
          }

          $(".toUse").css({
            color: "#afafaf",
          });
        }
      }
    },
    //领取优惠券
    ticketClick(item) {
      if (this.toUrl && this.ListText == "去使用") {
        this.$router.push({
          path: "/" + this.toUrl,
          query: { CouponInfo: this.CouponInfo, IconImg: this.IconImg },
        });
        return;
      }
      if (this.ListText == "已失效" || this.ListText == "已使用") {
        return;
      }
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/coupon/receive", {
            params: {
              uid: this.$store.state.useId,
              shop_id: item.shop_id,
              coupon_id: item.id,
            },
          })
          .then((res) => {
            if (res.data.code == 1) {
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", { show: true, type: true }); //显示领取成功
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", {
                show: true,
                type: false,
                msg: res.data.msg,
              }); //显示领取失败
            }
          });
      }
    },
    shareCoupon(data) {
      var that = this;
      this.$store.commit("showShareCoupon", true);
      var IsPhone = /iphone/.test(navigator.userAgent.toLowerCase()); //判断是不是苹果
      console.log("IsPhone", IsPhone);
      console.log(encodeURIComponent(window.entryUrl));
      console.log(encodeURIComponent(location.href));
      this.$http
        .get("/api/shop/get_SignPackage", {
          params: {
            url: encodeURIComponent(location.href),
          },
        })
        .then((res) => {
          console.log(res.data.msg);
          that.$store.commit("wxJSSDK", res.data.msg);
          wx.config({
            debug: false, // true:调试时候弹窗
            appId: res.data.msg.appId, // 微信appid
            timestamp: res.data.msg.timestamp, // 时间戳
            nonceStr: res.data.msg.nonceStr, // 随机字符串
            signature: res.data.msg.signature, // 签名
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "onMenuShareAppMessage", //获取地理位置
            ],
          });
        });
      wx.ready(function () {
        wx.onMenuShareAppMessage({
          title: "分享商家", // 分享标题
          desc: "核销优惠券", // 分享描述
          link:
            window.location.origin +
            "/redirect.html?shareRedirect=" +
            encodeURIComponent(
              "https://zqconsumer.zeego2.cc#/?type=giveTo&pcodes=" +
                that.codesEWM +
                "&id=" +
                that.$store.state.useId
            ), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imageUrl, // 分享图标
          success: function () {
            that.shareIMG();
            console.log("分享成功");
            console.log("uid", that.$store.state.useId);
            that.$http
              .get("api/coupon/share_save_coupon", {
                params: {
                  code: that.codesEWM,
                  uid: that.$store.state.useId,
                },
              })
              .then((res) => {
                console.log("分享请求", res);
              });
            // 设置成功
          },
          cancel: function () {
            that.$store.commit("showShareCoupon", false);
          },
        });
      });
      wx.error(function () {
        console.log("失败");
      });
    },
    shareIMG() {
      this.$store.commit("showShareCoupon", false);
      this.$store.commit("showMsg", {
        show: true,
        type: true,
        msg: "分享成功",
      }); //显示领取成功
    },
  },
  watch: {
    MycouponIndex(newValue, oldValue) {
      // console.log(newValue, oldValue);
      this.MycouponIndex = newValue;
      if (newValue == 0) {
        this.ListText = "去使用";
      }
      this.change();
    },
  },
};
</script>
<style lang='scss' scoped>
.share {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 100%;
  background: #f2d1d0;
  color: #cd160d;
  text-align: center;
  line-height: 0.8rem;
  margin-right: 0.5rem;
  flex-shrink: 0;
}
.Mycoupon {
  height: 1.62rem;
  background-repeat: no-repeat;
  background-image: url(../assets/Mycoupon.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.1rem;
  position: relative;
}
.toUse {
  width: 0.4rem;
  font-size: 0.28rem;
  color: #cd160d;
  margin-right: 0.25rem;
  text-align: center;
}
.tabTicketLeft {
  width: 5.8rem;
  height: 100%;
  padding-left: 0.3rem;
  color: #ffe5a6;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.TickGoodMoney {
  width: 1.26rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.TickGoodMoney > span:nth-child(1) {
  font-size: 0.26rem;
  color: #ffffff;
  margin-top: 0.1rem;
}
.TickGoodMoney > span:nth-child(2) {
  font-size: 0.66rem;
  color: #ffffff;
}
.tabTicketLeft .TickGoodMoney > span {
  color: #ffe5a6;
}
.tabTicketInfo div {
  font-size: 0.2rem;
  line-height: 0.32rem;
  height: 0.32rem;
  width: 2.5rem;
  overflow: hidden;
  /*不换行*/
  white-space: nowrap;
  /*添加...*/
  text-overflow: ellipsis;
}
.category {
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.32rem;
  color: #ffe5aa;
}
</style>
